import React from "react";
import { useTranslation } from "react-i18next";
import useProductName from "brand-customization/useProductName";
import { LinkContainer, DocumentTitle, PageHeader } from "components/common";
import withParams from "routing/withParams";
import { Button, Col, Row } from "components/bootstrap";
import ForwarderDocs from "forwarder/util/ForwarderDocs";
import withIsPermitted from "forwarder/util/withIsPermitted";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import { TELEMETRY_EVENT_TYPE } from "telemetry/Constants";
import ForwarderRoutes from "forwarder/Routes";
import ForwarderWizard from "./ForwarderWizard";
const REQUIRED_PERMISSIONS = [
  "forwarders:create",
  "forwarders:edit",
  "forwarders:read",
  "inputprofiles:create",
  "inputprofiles:edit",
  "inputprofiles:read",
  "forwarderinputs:create",
  "forwarderinputs:edit",
  "forwarderinputs:read"
];
const ForwarderWizardPage = ({ params }) => {
  const { t } = useTranslation("enterprise_forwarder");
  const productName = useProductName();
  const pageHeader = params && params.forwarderId ? t("forwarder_wizard_page.configure_forwarder") : t("forwarder_wizard_page.new_forwarder");
  const sendTelemetry = useSendTelemetry("forwarder-wizard");
  const onForwarderSetupExit = () => {
    sendTelemetry(TELEMETRY_EVENT_TYPE.FORWARDER.FORWARDER_WIZARD_SETUP_CANCELED, {
      app_pathname: "forwarder"
    });
  };
  return /* @__PURE__ */ React.createElement(DocumentTitle, { title: pageHeader }, /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    PageHeader,
    {
      title: pageHeader,
      documentationLink: {
        title: t("common.forwarder_documentation"),
        path: ForwarderDocs.FORWARDER
      },
      actions: /* @__PURE__ */ React.createElement(LinkContainer, { onClick: () => onForwarderSetupExit(), to: ForwarderRoutes.LIST }, /* @__PURE__ */ React.createElement(Button, { bsStyle: "info" }, t("forwarder_wizard_page.exit_setup")))
    },
    /* @__PURE__ */ React.createElement("span", null, t("forwarder_wizard_page.description", { productName }))
  ), /* @__PURE__ */ React.createElement(Row, { className: "content" }, /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement(ForwarderWizard, { forwarderId: params && params.forwarderId })))));
};
export default withParams(withIsPermitted(ForwarderWizardPage, REQUIRED_PERMISSIONS));
